<template>
  <v-row align-content="center" justify="start">
    <v-dialog
      v-model="dialog"
      persistent
      width="700"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn
          color="green"
          size="x-small"
          variant="plain"
          append-icon="mdi-plus"
          v-bind="props"
          >Associar Requisitos</v-btn
        >
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Associar Requisito</span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>
        <v-container>
          <v-row align-content="center">
            <v-progress-circular
              v-if="isReqLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
            <v-select
              :disabled="isReqLoading"
              v-model="ReqSelecionados"
              :items="nomesReq"
              label="Requisitos associados"
              multiple
            ></v-select>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" variant="text" @click="associateReq">
            Salvar
            <v-progress-circular
              v-if="this.isLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script scoped>
import axios from 'axios';

import store from '@/store/store';

export default {
  emits: ['requisitosAssociados'],
  data: () => ({
    idProjeto: null,
    csuID: null,
    requisitos: null,
    ReqSelecionados: [],
    idsReqAssociado: [],
    nomesReq: [],
    dialog: false,
    isReqLoading: true,
    isLoading: false,
  }),
  created() {
    this.idProjeto = this.$route.params.idProjeto;
    this.projeto = localStorage.getItem('projeto');
    this.csuID = this.$route.params.id;
    this.getRequisitosByProject();
    this.getRequisitosByCasoDeUso();
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    async getAllSelectedReqIDs() {
      try {
        this.ReqSelecionados.forEach((i) => {
          var temp = this.requisitos.find((x) => x.identificacao === i);
          this.idsReqAssociado.push(temp.id_requisito);
        });
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Método assíncrono para obter os requisitos do projeto.
     */
    async getRequisitosByProject() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/api/v1/requisitos/projeto/${this.idProjeto}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.requisitos = response.data;
        this.requisitos.forEach((element) => {
          this.nomesReq.push(element.identificacao);
        });
      } catch (error) {
        console.log(error);
      }
      this.isReqLoading = false;
    },
    /**
     * Obtém a lista de requisitos associados a um caso de uso.
     */
    async getRequisitosByCasoDeUso() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/api/v1/requisitos/csu/${this.csuID}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.requisitos = response.data;
        this.requisitos.forEach((element) => {
          this.ReqSelecionados.push(element.identificacao);
        });
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },
    /**
     * Envia o formulário.
     */
    async associateReq() {
      this.getAllSelectedReqIDs();
      const data = this.idsReqAssociado;
      try {
        this.isLoading = true;
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.post(
          `${apiUrl}/api/v1/requisitos/csu/${this.csuID}/associar`,
          data,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );

        this.$toast.success(response.data.msg);
        this.$emit('requisitosAssociados');
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.msg);
      } finally {
        this.isLoading = false;
        this.dialog = false;
        this.idsReqAssociado = [];
      }
    },
  },
};
</script>
